<template>
  <div class="pl_webapp">
    <!-- 浏览器安装 -->
    <div class="webapp_download" @click="handleInstallClick" v-if="isInstallPromptSupported">
      <div class="icon icon_download" :class="isMobile ? 'mobile' : 'desktop'"></div>
      <p class="text">{{ isMobile ? $t('pwa.home') : $t('game.app') }}</p>
    </div>
    <div class="webapp_download" @click="imgis = true" v-if="!isInstallPromptSupported && isMobile">
      <div class="icon icon_download" :class="isMobile ? 'mobile' : 'desktop'"></div>
      <p class="text">{{ isMobile ? $t('pwa.home') : $t('game.app') }}</p>
    </div>

    <!-- 浏览器收藏 -->
    <div class="webapp_download webapp_star" v-if="!isMobile" @click.stop="handleBookmarkClick">
      <div class="icon icon_collect"></div>
      <p class="text">{{ $t('game.bookmark') }}</p>
      <transition name="pop-up">
        <div class="webapp_toast" key="bookmarkis" v-if="bookmarkis">
          <p>{{ isMacOS ? $t('game.bookmarkMove') : $t('game.bookmarkMoveWin') }}</p>
          <div class="star_tip"></div>
        </div>
      </transition>
    </div>

    <!-- 加桌引导：常驻挂载，避免 isMobile 为 false 时（部分 iOS）Bus 打开 imgis 仍无 Dialog -->
    <Dialog
      :visible.sync="imgis"
      :title="$t('game.app')"
      :confirmText="$t('game.know')"
      @touchmove.native.prevent
    >
      <div class="webapp_img">
        <div class="img" :class="[IOSis ? 'ios' : 'android', $i18n.locale]"></div>
        <div class="browserinfodiv">{{ $t('game.browserInfo') }}</div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      bookmarkis: false,
      isMacOS: navigator.platform.toLowerCase().includes('mac'),
      isInstallPromptSupported: false,
      deferredPrompt: null,
      imgis: false,
      IOSis: false,
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.app.isMobile,
    }),
  },
  created() {
    document.body.addEventListener('click', () => {
      this.bookmarkis = false
    })
    this.$root.Bus.$on('headHideOther', (str) => {
      str !== 'bookmarkis' && (this.bookmarkis = false)
    })
    /** 任务弹窗「GO TO」：仅 task 发出，收到即打开（内部已区分是否该引导） */
    this._busOpenPwaAddToHomeGuide = () => {
      if (this.deferredPrompt) {
        this.handleInstallClick()
      } else {
        this.imgis = true
      }
    }
    this.$root.Bus.$on('openPwaAddToHomeGuide', this._busOpenPwaAddToHomeGuide)
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.deferredPrompt = e
      this.isInstallPromptSupported = true
      this.$store.commit('app/SET_IS_INSTALL_PROMPT_SUPPORTED', true)
    })

    this.IOSis = this.isIOS()
  },
  methods: {
    handleBookmarkClick() {
      if (!this.bookmarkis) {
        this.$root.Bus.$emit('headHideOther', 'bookmarkis')
      }
      this.bookmarkis = !this.bookmarkis
    },
    handleInstallClick() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt()
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('用户接受安装')
            this.isInstallPromptSupported = false
            this.$store.commit('app/SET_IS_INSTALL_PROMPT_SUPPORTED', false)
          } else {
            console.log('用户取消安装')
          }
          this.deferredPrompt = null
        })
      }
    },
    isIOS() {
      return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    },
    //引导图
    appinstallimg() {
      this.imgis = true
    },
  },
}
</script>

<style lang="less" scoped>
.pl_webapp {
  display: flex;
  gap: 8px;
  margin: 0 4px;
}
.webapp_download {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 30px;
    height: 30px;
    &.icon_download {
      .bg-image('icon_pwa');
      &.mobile {
        .bg-image('icon_savetophone');
        &:active {
          opacity: 0.6;
        }
      }
    }
    &.icon_collect {
      .bg-image('icon_collect');
    }
  }
  .text {
    display: none;
  }
}

.webapp_toast {
  position: absolute;
  top: 40px;
  display: block;
  background-color: #fff;
  box-shadow: 0px 10px 25px 4px rgba(0, 0, 0, 0.18);
  border-radius: 10px;
  cursor: default;
  p {
    width: 230px;
    font-size: 14px;
    text-align: center;
    white-space: pre-wrap;
    color: #202226;
    line-height: 20px;
    padding: 15px 10px;
    display: block;
  }

  .star_tip {
    .bg-image('star_tip');
    background-size: auto 100%;
    width: 100%;
    height: 55px;
    margin-bottom: 10px;
  }
}

.mask {
  display: flex;
  align-items: center;
}

.webapp_img {
  .browserinfodiv {
    display: block;
    text-align: center;
    color: #787878;
    font-size: 14px;
    height: auto;
    padding: 0 16px;
    white-space: normal;
  }

  .img {
    width: 100%;
    padding-top: 58.33333%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    &.ios {
      background-image: url('@img/webapp_guide/EN/webshop_ios.png');
      &.EN {
        background-image: url('@img/webapp_guide/EN/webshop_ios.png');
      }
      &.DE {
        background-image: url('@img/webapp_guide/DE/webshop_ios.png');
      }
      &.FR {
        background-image: url('@img/webapp_guide/FR/webshop_ios.png');
      }
      &.JA {
        background-image: url('@img/webapp_guide/JA/webshop_ios.png');
      }
      &.KO {
        background-image: url('@img/webapp_guide/KO/webshop_ios.png');
      }
      &.zh-Hant {
        background-image: url('@img/webapp_guide/zh-Hant/webshop_ios.png');
      }
      &.zh-Hans {
        background-image: url('@img/webapp_guide/zh-Hans/webshop_ios.png');
      }
      &.ES {
        background-image: url('@img/webapp_guide/ES/webshop_ios.png');
      }
      &.TH {
        background-image: url('@img/webapp_guide/TH/webshop_ios.png');
      }
      &.ID {
        background-image: url('@img/webapp_guide/ID/webshop_ios.png');
      }
      &.RU {
        background-image: url('@img/webapp_guide/RU/webshop_ios.png');
      }
      &.AR {
        background-image: url('@img/webapp_guide/AR/webshop_ios.png');
      }
      &.VI {
        background-image: url('@img/webapp_guide/VI/webshop_ios.png');
      }
      &.PT {
        background-image: url('@img/webapp_guide/PT/webshop_ios.png');
      }
      &.TR {
        background-image: url('@img/webapp_guide/TR/webshop_ios.png');
      }
      &.IT {
        background-image: url('@img/webapp_guide/IT/webshop_ios.png');
      }
      &.NL {
        background-image: url('@img/webapp_guide/NL/webshop_ios.png');
      }
      &.PL {
        background-image: url('@img/webapp_guide/PL/webshop_ios.png');
      }
    }
    &.android {
      background-image: url('@img/webapp_guide/EN/webshop_ad.png');
      &.EN {
        background-image: url('@img/webapp_guide/EN/webshop_ad.png');
      }
      &.DE {
        background-image: url('@img/webapp_guide/DE/webshop_ad.png');
      }
      &.FR {
        background-image: url('@img/webapp_guide/FR/webshop_ad.png');
      }
      &.JA {
        background-image: url('@img/webapp_guide/JA/webshop_ad.png');
      }
      &.KO {
        background-image: url('@img/webapp_guide/KO/webshop_ad.png');
      }
      &.zh-Hant {
        background-image: url('@img/webapp_guide/zh-Hant/webshop_ad.png');
      }
      &.zh-Hans {
        background-image: url('@img/webapp_guide/zh-Hans/webshop_ad.png');
      }
      &.ES {
        background-image: url('@img/webapp_guide/ES/webshop_ad.png');
      }
      &.TH {
        background-image: url('@img/webapp_guide/TH/webshop_ad.png');
      }
      &.ID {
        background-image: url('@img/webapp_guide/ID/webshop_ad.png');
      }
      &.RU {
        background-image: url('@img/webapp_guide/RU/webshop_ad.png');
      }
      &.AR {
        background-image: url('@img/webapp_guide/AR/webshop_ad.png');
      }
      &.VI {
        background-image: url('@img/webapp_guide/VI/webshop_ad.png');
      }
      &.PT {
        background-image: url('@img/webapp_guide/PT/webshop_ad.png');
      }
      &.TR {
        background-image: url('@img/webapp_guide/TR/webshop_ad.png');
      }
      &.IT {
        background-image: url('@img/webapp_guide/IT/webshop_ad.png');
      }
      &.NL {
        background-image: url('@img/webapp_guide/NL/webshop_ad.png');
      }
      &.PL {
        background-image: url('@img/webapp_guide/PL/webshop_ad.png');
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .webapp_download {
    border: 1px solid #ffffff;
    border-radius: 12px;
    height: 28px;
    padding: 0 8px;
    .icon {
      width: 22px;
      height: 22px;
      &.icon_download {
        &.mobile {
          &:active {
            opacity: 1;
          }
        }
      }
    }
    .text {
      display: block;
      font-size: 13px;
      color: #ffffff;
      margin: 0 8px;
    }
  }
}
</style>
